export default __webpack_public_path__ + "media/d99515c6c03b5570daaa5df7c6c1d0071766be8efd2806ca936d5ac999e92f3a.svg";